import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SiteLayout, PageHero, SectionTag, INDUSTRIES, useSEO } from "./shared";

export default function Industries() {
  useSEO(
    "Industries We Serve | SecureFlame Fire Systems Tripura",
    "SecureFlame Fire Systems installs and maintains fire protection systems across government, healthcare, hospitality, residential, commercial and industrial buildings in Tripura."
  );
  return (
    <SiteLayout>
      <PageHero eyebrow="Industries We Serve" title="Trusted Across Every Sector" subtitle="From government buildings to industrial facilities, SecureFlame designs fire protection systems suited to each building type." />

      <section className="max-w-7xl mx-auto px-6 py-16 md:py-20">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {INDUSTRIES.map((ind) => (
            <div key={ind.title} className="bg-card border border-border rounded-sm p-6 text-center hover:border-primary/40 hover:shadow-md transition-all" data-testid={`industry-card-${ind.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <ind.icon className="text-primary mx-auto mb-3" size={30} />
              <p className="text-sm font-semibold text-secondary">{ind.title}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="relative blueprint-bg text-white">
        <div className="relative max-w-4xl mx-auto px-6 py-16 md:py-20 text-center">
          <SectionTag light>Every Building Is Different</SectionTag>
          <h2 className="font-heading font-black text-3xl sm:text-4xl tracking-tight">Discuss Your Building Requirements</h2>
          <p className="mt-4 text-slate-300 max-w-xl mx-auto">Tell us about your property type and we'll recommend a suitable fire protection approach.</p>
          <Link to="/contact"><Button size="lg" className="mt-8 rounded-sm bg-primary hover:bg-primary/90 font-semibold gap-2" data-testid="industries-cta-btn">DISCUSS YOUR REQUIREMENTS <ArrowRight size={18} /></Button></Link>
        </div>
      </section>
    </SiteLayout>
  );
}
